<template>
  <div class="project-detail">
    <h1>{{ project.nombre }}</h1>
    <p>{{ project.descripcion }}</p>
    <div class="overline">tecnología</div>
    <p>{{ project.tecnologias }}</p>
    <slot name="return-button"></slot>
    <div class="images-container col-10">
      <v-row>
        <v-col
          v-for="image in project.images"
          :key="image.nombre"
          class="d-flex child-flex"
          cols="4"
        >
          <ImagenProjectToFull
            :url-image="image.path"
            :name="image.nombre"
          ></ImagenProjectToFull>
        </v-col>
      </v-row>
    </div>
    <br />
    <br />
  </div>
</template>

<script>
import ImagenProjectToFull from '@/components/normal/ImagenProjectToFull'

export default {
  components: { ImagenProjectToFull },
  props: {
    project: Object
  }
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';

.project-detail {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>
